/**
 * This is necessary because currently we have two different market program representations:
 * 1. 'FCR_D_UP_DYNAMIC', 'FCR_D_DOWN_DYNAMIC', 'FCR_D_UP_STATIC', 'FCR_N'
 * 2. 'fcr-d-up-dynamic', 'fcr-d-down-dynamic', 'fcr-d-up-static', 'fcr-n'
 *
 * We called the second representation MarketProgramType, and currently we linked the translations to this representation.
 *
 * The second representation is going to be the standard way to represent market programs in the future, but
 * it requires some work from the backend to be able to use it.
 *
 * This function converts the first representation to the second one, so market programs can be translated properly.
 *
 * The return type is deliberately `string` and not `MarketProgramType`: the insights API also
 * carries values outside that union (the BRP programs such as 'wholesale-fees', and granular
 * capacity/energy variants), so asserting the union here would lie to the type checker.
 */
export function convertToStandardMarketProgramType(standardMarketProgram: string): string {
  return standardMarketProgram.toLocaleLowerCase().replaceAll('_', '-')
}
